import React from 'react';

// ─── Data ────────────────────────────────────────────────────────────────────
const ROW1 = [
  { quote: "I wanted live music for my house party but had no idea where to find a good singer. MusicalMeet made it incredibly easy. The artist was amazing and became the highlight of the evening.", name: "Priya S.", location: "Chennai", tag: "Event Host" },
  { quote: "Booking a live performer felt complicated until I found MusicalMeet. The entire process was smooth, transparent, and stress-free. My guests are still talking about the performance!", name: "Rahul M.", location: "Gurgaon", tag: "Event Host" },
  { quote: "We booked a singer for my parents' anniversary, and it completely transformed the atmosphere. It felt personal, memorable, and special.", name: "Ananya K.", location: "Mumbai", tag: "Event Host" },
  { quote: "Why play music through speakers when you can have a live artist? MusicalMeet helped us create an unforgettable birthday celebration.", name: "Vikram A.", location: "Delhi", tag: "Event Host" },
  { quote: "The artist connected with the audience so well that even people who usually don't dance were singing along. Best decision we made for our event.", name: "Sanjana P.", location: "Bangalore", tag: "Event Host" },
];

const ROW2 = [
  { quote: "Before MusicalMeet, I relied mostly on referrals. Through the platform, I started getting genuine performance opportunities and exposure to new audiences.", name: "Koushal", location: "Singer", tag: "Artist" },
  { quote: "My first booking through MusicalMeet gave me the confidence to perform live regularly. The audience response was incredible and opened new doors for me.", name: "Koushal", location: "Singer", tag: "Artist" },
  { quote: "MusicalMeet doesn't just help artists find gigs — it helps us build our identity as performers. Every event becomes an opportunity to grow.", name: "Ritika", location: "Acoustic Singer", tag: "Artist" },
  { quote: "The platform brings serious clients who genuinely value live music. That makes a huge difference for independent artists like me.", name: "Aman", location: "Guitarist", tag: "Artist" },
  { quote: "Instead of spending hours promoting myself online, I can focus on my music while MusicalMeet helps me connect with people who want live performances.", name: "Harsh", location: "Pianist", tag: "Artist" },
];

// ─── Card ─────────────────────────────────────────────────────────────────────
function Card({ quote, name, location, tag }) {
  const isArtist = tag === 'Artist';
  return (
    <div style={{
      flexShrink: 0,
      width: 320,
      background: 'rgba(255,255,255,0.04)',
      border: '1px solid rgba(255,255,255,0.08)',
      borderRadius: 16,
      padding: '22px 24px',
      marginRight: 20,
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
      userSelect: 'none',
    }}>
      {/* Quote mark */}
      <div style={{ color: isArtist ? '#c4b5fd' : '#818cf8', fontSize: '2.2rem', lineHeight: 1, fontFamily: 'Georgia, serif', opacity: 0.6 }}>"</div>
      <p style={{ fontFamily: 'Poppins, sans-serif', color: '#cbd5e1', fontSize: '0.88rem', lineHeight: 1.75, margin: 0, flex: 1 }}>
        {quote}
      </p>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, paddingTop: 12, borderTop: '1px solid rgba(255,255,255,0.07)' }}>
        {/* Avatar initials */}
        <div style={{
          width: 38, height: 38, borderRadius: '50%', flexShrink: 0,
          background: isArtist ? 'linear-gradient(135deg,#7c3aed,#a78bfa)' : 'linear-gradient(135deg,#374EA9,#818cf8)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontFamily: 'Gilroy-semiBold, sans-serif', color: '#fff', fontSize: '0.9rem',
        }}>
          {name[0]}
        </div>
        <div>
          <p style={{ fontFamily: 'Gilroy-semiBold, sans-serif', color: '#f1f5f9', fontSize: '0.88rem', margin: '0 0 2px' }}>
            {name}
          </p>
          <p style={{ fontFamily: 'Poppins, sans-serif', color: '#64748b', fontSize: '0.76rem', margin: 0 }}>
            {location}
          </p>
        </div>
        <span style={{
          marginLeft: 'auto', flexShrink: 0,
          background: isArtist ? 'rgba(124,58,237,0.15)' : 'rgba(55,78,169,0.15)',
          border: `1px solid ${isArtist ? 'rgba(124,58,237,0.35)' : 'rgba(55,78,169,0.35)'}`,
          color: isArtist ? '#c4b5fd' : '#a5b4fc',
          borderRadius: 99, padding: '3px 10px',
          fontFamily: 'Gilroy-semiBold, sans-serif', fontSize: '0.68rem',
        }}>
          {tag}
        </span>
      </div>
    </div>
  );
}

// ─── Marquee Row ──────────────────────────────────────────────────────────────
function MarqueeRow({ items, reverse = false, duration = 40 }) {
  // Duplicate for seamless loop
  const doubled = [...items, ...items];
  return (
    <div style={{ overflow: 'hidden', maskImage: 'linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)', WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)' }}>
      <div style={{
        display: 'flex',
        animation: `marquee${reverse ? 'Rev' : ''} ${duration}s linear infinite`,
        width: 'max-content',
      }}>
        {doubled.map((item, i) => (
          <Card key={i} {...item} />
        ))}
      </div>
    </div>
  );
}

// ─── Main Component ───────────────────────────────────────────────────────────
export default function TestimonialsScroll() {
  return (
    <section style={{ background: '#0f172a', padding: '20px 20px', overflow: 'hidden' }}>
      <style>{`
        @keyframes marquee {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes marqueeRev {
          0%   { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
      `}</style>

      {/* Header */}
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 24px', textAlign: 'center', marginBottom: 56 }}>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: 'rgba(99,102,241,0.12)', border: '1px solid rgba(99,102,241,0.3)', borderRadius: 99, padding: '6px 18px', fontFamily: 'Gilroy-semiBold, sans-serif', color: '#a5b4fc', fontSize: '0.82rem', marginBottom: 20 }}>
          ★ Testimonials
        </span>
        <h2 style={{ fontFamily: 'Gilroy-semiBold, sans-serif', fontSize: 'clamp(1.8rem,4vw,2.6rem)', color: '#fff', margin: '0 0 14px', lineHeight: 1.2 }}>
          Loved by artists &{' '}
          <span style={{ background: 'linear-gradient(135deg,#818cf8,#c4b5fd)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
            event hosts
          </span>
        </h2>
        <p style={{ fontFamily: 'Poppins, sans-serif', color: '#64748b', fontSize: '1rem', margin: 0 }}>
          Real experiences from musicians and people who brought live music to their events.
        </p>
      </div>

      {/* Single row — all testimonials, scrolls left */}
      <MarqueeRow items={[...ROW1, ...ROW2]} reverse={false} duration={60} />
    </section>
  );
}
